import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { PreviewContext } from '../preview.types';
import { getHeaderPreviewData } from '../preview-style.resolver';

@Component({
  selector: 'app-header-section-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-section-preview.html',
  styleUrl: './header-section-preview.scss',
})
export class HeaderSectionPreviewComponent {
  @Input() context: PreviewContext | null = null;
  @Input() viewMode: 'web' | 'mobile' = 'web';

  get data() {
    return getHeaderPreviewData(this.context);
  }
}
